import * as React from 'react';
import { Row, Col, Collapse, Tooltip } from 'reactstrap';
import styled from 'styled-components';
import PlusMinusSelector from './PlusMinusSelector';
import DownArrow from 'src/assets/icons/DownArrow.svg';
import UpArrow from 'src/assets/icons/UpArrow.svg';
import info from 'src/assets/icons/info.svg';

const AddHouseHoldItemsButton = styled.button`
  width: 100%;
  height: 37px;

  background: #f5f5f5;
  border: none;
  border-top: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 0px 0px 4px 4px;

  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  color: #00144d;
  display: block;
  align-items: center;

  :focus {
    outline: none;
  }
`;

const VolumeSelectorsContainer = styled.div`
  background: #ffffff;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 4px;
`;

const SelectorsContainer = styled.div`
  box-sizing: border-box;

  .row {
    margin-top: 26px;
  }
`;

const RowTitleText = styled.p`
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 1rem;
  color: #333333;
  margin-bottom: 2px;
`;

const RowTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const RowDetailText = styled.p`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 12px;

  color: #828282;
  margin-bottom: 0;
`;

const StyledImg = styled.img``;

interface props {
  style?: React.CSSProperties;
  standardBoxes?: number;
  mediumItems?: number;
  largeItems?: number;
  extraLargeItems?: number;
  enormousItems?: number;
  onStandardBoxChange?: (value: number) => void;
  onMediumChange?: (value: number) => void;
  onLargeChange?: (value: number) => void;
  onExtraLargeChange?: (value: number) => void;
  onEmormousChange?: (value: number) => void;
  open?: boolean;
}

interface state {
  householdItemsOpen: boolean;
  standardTooltipVisible: boolean;
  mediumTooltipVisible: boolean;
  largeTooltipVisible: boolean;
  extraLargeTooltipVisible: boolean;
  enormousTooltipVisible: boolean;
}

class VolumeSelectors extends React.Component<props, state> {
  state = {
    householdItemsOpen: this.props.open || false,
    standardTooltipVisible: false,
    mediumTooltipVisible: false,
    largeTooltipVisible: false,
    extraLargeTooltipVisible: false,
    enormousTooltipVisible: false,
  };

  toggleStandard = () => {
    this.setState({ standardTooltipVisible: !this.state.standardTooltipVisible });
  };

  toggleMedium = () => {
    this.setState({ mediumTooltipVisible: !this.state.mediumTooltipVisible });
  };

  toggleLarge = () => {
    this.setState({ largeTooltipVisible: !this.state.largeTooltipVisible });
  };

  toggleExtraLarge = () => {
    this.setState({ extraLargeTooltipVisible: !this.state.extraLargeTooltipVisible });
  };

  toggleEnormous = () => {
    this.setState({ enormousTooltipVisible: !this.state.enormousTooltipVisible });
  };

  render() {
    return (
      <VolumeSelectorsContainer style={this.props.style}>
        <SelectorsContainer>
          <Row style={{ padding: 16, marginTop: 0 }}>
            <Col xs={{ size: 6, offset: 0 }}>
              <RowTitleContainer>
                <RowTitleText> Standard Box</RowTitleText>
                <StyledImg
                  src={info}
                  style={{ marginTop: '-16px', marginLeft: '4px' }}
                  id="StandardInfo"
                />
                <Tooltip
                  placement="right"
                  isOpen={this.state.standardTooltipVisible}
                  target="StandardInfo"
                  toggle={this.toggleStandard}
                >
                  The average Penn student needs about 5 of these <br /> ($23 / box)
                </Tooltip>
              </RowTitleContainer>
              <RowDetailText>24 x 18 x 16 inches</RowDetailText>
            </Col>
            <Col xs={{ size: 6, offset: 0 }}>
              <PlusMinusSelector
                onChange={this.props.onStandardBoxChange}
                value={this.props.standardBoxes}
              />
            </Col>
          </Row>
          <Collapse isOpen={this.state.householdItemsOpen}>
            <hr style={{ margin: 0, borderColor: '#bdbdbd' }} />
            <div style={{ padding: 16 }}>
              <Row style={{ marginTop: 0 }}>
                <Col xs={{ size: 6, offset: 0 }}>
                  <RowTitleContainer>
                    <RowTitleText>Medium Items</RowTitleText>
                    <StyledImg
                      src={info}
                      style={{ marginTop: '-16px', marginLeft: '4px' }}
                      id="MediumInfo"
                    />
                    <Tooltip
                      placement="right"
                      isOpen={this.state.mediumTooltipVisible}
                      target="MediumInfo"
                      toggle={this.toggleMedium}
                    >
                      Small boxes, handbags, folding chairs, desk lamps, mirrors, ironing boards{' '}
                      <br />
                      ($20 / item)
                    </Tooltip>
                  </RowTitleContainer>
                  <RowDetailText>1 to 2 cubic feet</RowDetailText>
                </Col>
                <Col xs={{ size: 6, offset: 0 }}>
                  <PlusMinusSelector
                    onChange={this.props.onMediumChange}
                    value={this.props.mediumItems}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={{ size: 6, offset: 0 }}>
                  <RowTitleContainer>
                    <RowTitleText> Large Items</RowTitleText>
                    <StyledImg
                      src={info}
                      style={{ marginTop: '-16px', marginLeft: '4px' }}
                      id="LargeInfo"
                    />
                    <Tooltip
                      placement="right"
                      isOpen={this.state.largeTooltipVisible}
                      target="LargeInfo"
                      toggle={this.toggleLarge}
                    >
                      Bins, cube fridges, small rugs, carry-ons, microwaves <br /> ($30 / item)
                    </Tooltip>
                  </RowTitleContainer>
                  <RowDetailText>2 to 4 cubic feet</RowDetailText>
                </Col>
                <Col xs={{ size: 6, offset: 0 }}>
                  <PlusMinusSelector
                    onChange={this.props.onLargeChange}
                    value={this.props.largeItems}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={{ size: 6, offset: 0 }}>
                  <RowTitleContainer>
                    <RowTitleText style={{ fontSize: '0.9rem' }}> Extra Large Items</RowTitleText>
                    <StyledImg
                      src={info}
                      style={{ marginTop: '-16px', marginLeft: '4px' }}
                      id="ExtraLargeInfo"
                    />
                    <Tooltip
                      placement="right"
                      isOpen={this.state.extraLargeTooltipVisible}
                      target="ExtraLargeInfo"
                      toggle={this.toggleExtraLarge}
                    >
                      Guitars, duffles, chairs, tables <br /> ($40 / item)
                    </Tooltip>
                  </RowTitleContainer>
                  <RowDetailText>4 to 5 cubic feet</RowDetailText>
                </Col>
                <Col xs={{ size: 6, offset: 0 }}>
                  <PlusMinusSelector
                    onChange={this.props.onExtraLargeChange}
                    value={this.props.extraLargeItems}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={{ size: 6, offset: 0 }}>
                  <RowTitleContainer>
                    <RowTitleText style={{ fontSize: '0.9rem' }}> Enormous Items</RowTitleText>
                    <StyledImg
                      src={info}
                      style={{ marginTop: '-16px', marginLeft: '4px' }}
                      id="EnormousInfo"
                    />
                    <Tooltip
                      placement="right"
                      isOpen={this.state.enormousTooltipVisible}
                      target="EnormousInfo"
                      toggle={this.toggleEnormous}
                    >
                      Fridges, luggage, bicycles <br /> ($50 / item)
                    </Tooltip>
                  </RowTitleContainer>
                  <RowDetailText>5 to 7 cubic feet</RowDetailText>
                </Col>
                <Col xs={{ size: 6, offset: 0 }}>
                  <PlusMinusSelector
                    onChange={this.props.onEmormousChange}
                    value={this.props.enormousItems}
                  />
                </Col>
              </Row>
            </div>
          </Collapse>
        </SelectorsContainer>
        <AddHouseHoldItemsButton
          onClick={() =>
            this.setState({
              householdItemsOpen: !this.state.householdItemsOpen,
            })
          }
        >
          <img
            src={this.state.householdItemsOpen ? UpArrow : DownArrow}
            style={{ marginLeft: 16, marginRight: 12 }}
            alt="chevron"
          />
          add larger items
        </AddHouseHoldItemsButton>
      </VolumeSelectorsContainer>
    );
  }
}

export default VolumeSelectors;



// WEBPACK FOOTER //
// ./src/components/FormComponents/VolumeSelectors.tsx